import { createFileRoute } from '@tanstack/react-router'
import FeaturedListsPage from '@/features/dashboard/pages/featured'

export const Route = createFileRoute('/(app)/dashboard/featured/')({
  component: FeaturedListsPage,
})
